
import { gatsbyMediaArray } from './gatsbyMedia'
import { hollyReviewerProfile, luigiReviewerProfile, frodoReviewerProfile } from './gatsbyReviewers'
import { frodoBio, hollyBio, luigiBio, gatsbyBio } from './gatsbyBios'
import { gatsbyDatingProfileHinge, gatsbyDatingProfileBumble, gatsbyDatingProfileTinder } from './gatsbyDatingProfiles'

export const gatsbyUser = {
  _id: 'gatsbyUserId',
  email: 'gatsby@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...hollyReviewerProfile },
    { ...luigiReviewerProfile },
    { ...frodoReviewerProfile }
  ],
  media: [ ...gatsbyMediaArray ],
  bio: { ...gatsbyBio },
  datingProfiles: [
    { ...gatsbyDatingProfileHinge },
    { ...gatsbyDatingProfileBumble },
    { ...gatsbyDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const hollyUser = {
  _id: 'hollyUserId',
  email: 'holly@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...hollyBio },
  datingProfiles: [],
  reviewerProfile: { ...hollyReviewerProfile },
}

export const luigiUser = {
  _id: 'luigiUserId',
  email: 'luigi@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...luigiBio },
  datingProfiles: [],
  reviewerProfile: { ...luigiReviewerProfile },
}

export const frodoUser = {
  _id: 'frodoUserId',
  email: 'frodo@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...frodoBio },
  datingProfiles: [],
  reviewerProfile: { ...frodoReviewerProfile },
}
